export const feeUnitEnums = {
  1: "ヶ月",
  2: "円",
  3: "%"
};
